'use strict'

import { apiInstance } from './index'

const coupon = {
  validateCouponSheet (formData) {
    return apiInstance({
      method: 'POST',
      url: '/b2b-coupon-app/coupon/sheet/validate',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    })
  },

  createCoupon (companyId, data) {
    return apiInstance({
      method: 'POST',
      url: `/b2b-coupon-app/coupon/company/${companyId}/process`,
      data
    })
  }
}

export default coupon
